/*
 * Buffers messages until a "BatchDone" is received
 */
import { buildLogger, Logger } from '@instinet-analytics/core-lib';
import {
    GetOrderColumnsMessage,
    OrderDataMessageDataItem,
    StreamMessageType,
} from 'communication/types/order/GetOrderColumnsMessage';
import { LoggingService } from '@instinet-analytics/core-lib';
import IntervalBuffer from 'utils/IntervalBuffer';

/*
 * Handles incremental updates (every 1000ms) of order messages
 */
export class OrdersMessageIncrementalBuffer {
    private logger: Logger;
    private intervalBuffer: IntervalBuffer<OrderDataMessageDataItem>;

    public constructor(
        loggingService: LoggingService,
        private out: (
            data: OrderDataMessageDataItem[],
            refreshDone: boolean,
            clearOrders: boolean
        ) => void
    ) {
        this.logger = buildLogger(
            'OrdersMessageIncrementalBuffer',
            loggingService
        );
        this.intervalBuffer = new IntervalBuffer(
            (data: OrderDataMessageDataItem[]) => {
                this.out(data, false, false);
            }
        );
    }

    public in(message: GetOrderColumnsMessage) {
        switch (message.type) {
            case StreamMessageType.ClearData:
            case StreamMessageType.RefreshDone: {
                this.logger.warn(
                    'Unexpected batch message received whilst in incremental update mode',
                    message
                );
                this.flush();
                this.out(
                    [],
                    message.type === StreamMessageType.RefreshDone,
                    message.type === StreamMessageType.ClearData
                );
                break;
            }
            case StreamMessageType.BatchData: {
                this.logger.warn(
                    'Unexpected BatchData message received whilst in incremental update mode'
                );
                this.intervalBuffer.in(message.data);
                break;
            }
            case StreamMessageType.BatchDone: {
                this.intervalBuffer.in(message.data);
                break;
            }
        }
    }

    public flush() {
        this.intervalBuffer.flush();
    }
}
